/// <amd-module name="Analytics/Boards/VelocityQueries/PlannedWorkByDayDetailsQuery" />
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { QueryUtilities } from "Analytics/Common/Utilities/QueryUtilities";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";
import { VelocityQueryBase } from "./VelocityQueryBase";

import { WorkItem } from "Analytics/Boards/BoardsQueries/DataContracts";
import { Iteration } from "Analytics/Boards/BoardsQueries/IterationsQuery";
import { PlannedWorkByDayQuery } from "./PlannedWorkByDayQuery";

/**
 * Exposes list of Work Items in Planned state for a given iteration.
 */
export class PlannedWorkByDayDetailsQuery extends VelocityQueryBase<WorkItem[]> {
    private static generateQueryOptions(
        projectId: string,
        teamId: string,
        iteration: Iteration,
        workItemTypes: string[],
        delay: number
    ): ODataQueryOptions {
        const isInAnyIterationAtIterationStartDate = PlannedWorkByDayQuery.isInAnyIterationAtStartDate([iteration], delay);

        const iterationAndCompletedDateClause = `(${isInAnyIterationAtIterationStartDate})`;
        const workItemTypeClause = QueryUtilities.isInArray("WorkItemType", workItemTypes, true /* useQuotes */);
        const earliestStartDateSK = PlannedWorkByDayQuery.getDelayedDateSK(iteration.StartDateTimeOffset || "", delay);

        const $apply =
            `filter(` +
            `Teams/any(t:t/TeamSK eq ${teamId})` +
            ` and (${workItemTypeClause})` +
            ` and (RevisedDateSK eq null or RevisedDateSK gt ${earliestStartDateSK})` + // Added to improve query perf
            ` and ${iterationAndCompletedDateClause}` +
            ` and StateCategory ne null)`;

        return {
            entityType: "WorkItemSnapshot",
            oDataVersion: latestODataVersion,
            project: projectId,
            $apply: $apply,
            $select: "WorkItemId"
        };
    }
    private queryName?: string;
    constructor(
        command: string,
        projectId: string,
        teamId: string,
        iteration: Iteration,
        workItemTypes: string[],
        delay: number,
        queryName?: string
    ) {
        super(command, PlannedWorkByDayDetailsQuery.generateQueryOptions(projectId, teamId, iteration, workItemTypes, delay));
        this.queryName = queryName;
    }

    public getQueryName(): string {
        return this.queryName || "PlannedWorkByDayDetailsQuery";
    }
}
